/* GINPACT — Scroll Reveal & Interaction Animations
   Lightweight IntersectionObserver approach — no GSAP/heavy lib needed.
   All effects degrade gracefully on low-power devices.
   ------------------------------------------------------------------ */

(function () {
  'use strict';

  /* ── Scroll reveal ── */
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  document.querySelectorAll('[data-animate], [data-stagger]').forEach((el) => {
    revealObserver.observe(el);
  });

  /* ── GINPACT section reveals (gp-reveal / gp-fade → gp-vis) ── */
  const gpObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('gp-vis');
          gpObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.07, rootMargin: '0px 0px -32px 0px' }
  );

  document.querySelectorAll('.gp-reveal, .gp-fade').forEach((el) => {
    gpObserver.observe(el);
  });

  /* Immediate reveal for hero elements */
  document.querySelectorAll('.gp-hero .gp-reveal, .gp-hero .gp-fade').forEach((el) => {
    const delay = parseFloat(getComputedStyle(el).transitionDelay || 0) * 1000;
    setTimeout(() => el.classList.add('gp-vis'), delay + 80);
  });

  /* ── Sticky header colour shift ── */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Smooth counter animation (for statistics sections) ── */
  function animateCounter(el) {
    const target = parseFloat(el.dataset.target);
    const duration = 1400;
    const start = performance.now();
    const isDecimal = String(target).includes('.');

    const tick = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = target * eased;
      el.textContent = isDecimal ? value.toFixed(1) : Math.floor(value).toLocaleString();
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  const counterObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  document.querySelectorAll('[data-counter]').forEach((el) => {
    counterObserver.observe(el);
  });

  /* ── Parallax-lite for hero background (subtle depth) ── */
  const heroMedia = document.querySelector('.gp-hero__bg');
  if (heroMedia && window.matchMedia('(min-width: 769px)').matches) {
    window.addEventListener(
      'scroll',
      () => {
        const offset = window.scrollY * 0.25;
        heroMedia.style.transform = `translateY(${offset}px)`;
      },
      { passive: true }
    );
  }

  /* ── Tab / accordion component ── */
  document.querySelectorAll('[data-tabs]').forEach((wrapper) => {
    const triggers = wrapper.querySelectorAll('[data-tab-trigger]');
    const panels = wrapper.querySelectorAll('[data-tab-panel]');

    triggers.forEach((trigger, i) => {
      trigger.addEventListener('click', () => {
        triggers.forEach((t) => t.classList.remove('active'));
        panels.forEach((p) => { p.hidden = true; p.classList.remove('active'); });
        trigger.classList.add('active');
        panels[i].hidden = false;
        panels[i].classList.add('active');
      });
    });
  });

  /* ── FAQ accordion ── */
  document.querySelectorAll('.faq__item').forEach((item) => {
    const trigger = item.querySelector('.faq__question');
    const answer = item.querySelector('.faq__answer');
    if (!trigger || !answer) return;

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq__item.open').forEach((openItem) => {
        openItem.classList.remove('open');
        openItem.querySelector('.faq__answer').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  /* ── Mobile navigation ── */
  const burger = document.querySelector('.header__burger');
  const mobileNav = document.querySelector('.header__nav');
  if (burger && mobileNav) {
    burger.addEventListener('click', () => {
      const expanded = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!expanded));
      mobileNav.classList.toggle('nav--open', !expanded);
    });
  }

  /* ── Hover tilt on product cards (subtle 3-D feel) ── */
  document.querySelectorAll('.product-card[data-tilt]').forEach((card) => {
    const intensity = 6;
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width - 0.5) * intensity;
      const y = -((e.clientY - rect.top) / rect.height - 0.5) * intensity;
      card.style.transform = `perspective(600px) rotateX(${y}deg) rotateY(${x}deg) translateY(-4px)`;
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = '';
    });
  });
})();
